import React, { Component } from 'react'
import { injectIntl } from 'react-intl'

import { Layout, Container, PageTitle } from 'src/components/Layout'
import List from 'src/components/List'
import { Loader } from 'src/components/Loader'

import intlMessages from '../translations'

class RemoveDriver extends Component {
  componentDidMount() {
    const { getDocumentDrivers, document } = this.props

    if (document && document.hasOwnProperty('policyNumber')) {
      getDocumentDrivers(document.policyNumber)
    }
  }

  getDriversList = (drivers = []) => {
    return drivers.reduce((result, driver) => {
      return [
        ...result,
        {
          leftIcon: 'Person',
          name: `${driver.firstName} ${driver.lastName}`,
          url: '/changepolicy/vehicle/driver/remove/confirmation',
          hideArrow: true,
          driver,
        },
      ]
    }, [])
  }

  handleClick = ({ driver }) => {
    this.props.setDocumentDriver(driver)
  }

  render() {
    const { drivers, intl, loading } = this.props

    return (
      <Layout>
        <PageTitle title={intl.formatMessage(intlMessages.documentRemoveDriverHeadline)} showBack />
        <Container padder>
          {loading ? (
            <Loader styleVariation='staticWithHeight' addDesktopBackgroundColor={true} />
          ) : (
            <List
              isOverflown={true}
              items={this.getDriversList(drivers)}
              onClick={this.handleClick}
              styleVariationDesktop='blocks'
              noResultsMessage={intl.formatMessage(intlMessages.documentRemoveDriverNoResults)}
            />
          )}
        </Container>
      </Layout>
    )
  }
}

export default injectIntl(RemoveDriver)
